import UIFlex from 'UIComponents/layout/UIFlex';
import H2 from 'UIComponents/elements/headings/H2';
import { COMMERCE_PAYMENT_TYPE_ID } from 'customer-data-objects/constants/ObjectTypeIds';
import FormattedPropertyV2 from 'customer-data-properties/formatted/FormattedPropertyV2';
import getPropertyValue from '../dataAccessHelpers/getPropertyValue';
import getPropertyDefinition from '../dataAccessHelpers/getPropertyDefinition';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const PaymentHighlightHeader = ({
  objectId,
  properties
}) => {
  const initialAmount = getPropertyValue(properties, 'hs_initial_amount');
  const paymentStatus = getPropertyValue(properties, 'hs_latest_status');
  return /*#__PURE__*/_jsxs(UIFlex, {
    align: "center",
    children: [/*#__PURE__*/_jsx(H2, {
      className: "text-left p-right-6",
      children: /*#__PURE__*/_jsx(FormattedPropertyV2, {
        "data-test-id": "payment-highlight-header-amount",
        objectTypeId: COMMERCE_PAYMENT_TYPE_ID,
        objectId: objectId,
        property: getPropertyDefinition(properties, 'hs_initial_amount'),
        value: initialAmount,
        getAdditionalPropertyValue: propertyName => getPropertyValue(properties, propertyName)
      })
    }), /*#__PURE__*/_jsx("span", {
      className: "m-bottom-4",
      children: /*#__PURE__*/_jsx(FormattedPropertyV2, {
        "data-test-id": "payment-highlight-header-status",
        objectTypeId: COMMERCE_PAYMENT_TYPE_ID,
        objectId: objectId,
        property: getPropertyDefinition(properties, 'hs_latest_status'),
        value: paymentStatus,
        getAdditionalPropertyValue: propertyName => getPropertyValue(properties, propertyName)
      })
    })]
  });
};
export default PaymentHighlightHeader;